var _g, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3134 24.6682V8.02071L23.8022 1.11044H4.68283C4.30728 1.11044 4 1.39314 4 1.73865V31.8925C4 32.2381 4.30728 32.5207 4.68283 32.5207H22.778",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3134 24.6682V8.02071L23.8022 1.11044H4.68283C4.30728 1.11044 4 1.39314 4 1.73865V31.8925C4 32.2381 4.30728 32.5207 4.68283 32.5207H22.778",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4851 8.02071H31.3134L23.8022 1.11044V7.39251C23.8022 7.73802 24.1095 8.02071 24.4851 8.02071Z",
    fill: "#A5B4BC",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12109 18.7002H26.5334",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77979 13.0464H26.1921",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77979 15.8733H26.1921",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12109 21.5271H26.5334",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12109 24.3541H15.608",
    stroke: "#64727A",
    strokeWidth: 0.693079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8168 25.3773L31.553 17.6452C31.3147 17.494 31.0142 17.494 30.7759 17.6452L18.5121 25.3773C18.4058 25.4437 18.3398 25.5616 18.3398 25.6907C18.3802 32.5563 20.495 41.9034 30.8199 47.4527C31.0362 47.5707 31.3037 47.5707 31.52 47.4527C41.8449 41.9071 43.9561 32.5563 44.0001 25.6907C44.0001 25.5616 43.9341 25.4437 43.8278 25.3773H43.8168Z",
    fill: "#AFE8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2011 45.1186C24.468 41.236 20.9054 35.0488 20.5939 26.7009L31.2011 20.0455L41.8082 26.7009C41.4967 35.0488 37.9341 41.236 31.2011 45.1186Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8168 25.3773L31.553 17.6452C31.3147 17.494 31.0142 17.494 30.7759 17.6452L18.5121 25.3773C18.4058 25.4437 18.3398 25.5616 18.3398 25.6907C18.3802 32.5563 20.495 41.9034 30.8199 47.4527C31.0362 47.5707 31.3037 47.5707 31.52 47.4527C41.8449 41.9071 43.9561 32.5563 44.0001 25.6907C44.0001 25.5616 43.9341 25.4437 43.8278 25.3773H43.8168Z",
    stroke: "#7CD1BB",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2011 45.1186C24.468 41.236 20.9054 35.0488 20.5939 26.7009L31.2011 20.0455L41.8082 26.7009C41.4967 35.0488 37.9341 41.236 31.2011 45.1186Z",
    stroke: "#7CD1BB",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4222 32.9031L29.9891 34.4675L33.5873 29.9111M37.2221 32.1111C37.2221 35.4861 34.4861 38.2221 31.1111 38.2221C27.736 38.2221 25 35.4861 25 32.1111C25 28.736 27.736 26 31.1111 26C34.4861 26 37.2221 28.736 37.2221 32.1111Z",
    stroke: "#006D5B",
    strokeWidth: 0.488886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/disclaimer_icon.4d2244f255b9164563cf41afd589420d.svg";
export { ForwardRef as ReactComponent };